import Vue from "vue";
import Dialog from "../components/progressDialog.vue"

const pConstructor = Vue.extend(Dialog);
const instance = new pConstructor().$mount();
document.body.appendChild(instance.$el);
// const progressDialog  =(option ={}) =>{
// }
// function progressHandler(type,value){ 
// // switch(type){
// //   case 'show' :
// // }
// return {
//   show:show
// }
// }

const show =(bool)=>{
  instance.show =bool
}

const text =(val)=>{
  instance.text =val ||'hello progress plugins'
}


const progressDialog ={
  show,
  text,
  events:[],
  progressList:[],
  addpEvent:{},
}


export default instance;
// const Dialog = {
//   duration: 3000, // 显示的时间 ms
//   animateTime: 300, // 动画时间,表示这个组件切换show的动画时间
// }

// 实现
// `
// vm.$progressDialog.close()
// vm.$progressDialog.add
// vm.name=
// `
